export const promoBannerCloseEventType = 'ok_promoBannerCloseEvent';

export function dispatchPromoBannerCloseEvent() {
    if (typeof window.CustomEvent === 'function') {
        window.document.dispatchEvent(new CustomEvent(promoBannerCloseEventType, {bubbles: true}));
    }
}
